module.exports = __webpack_public_path__ + "media/styles/images/svg/inline-arrow-up-gray-light-10532538b9dc30ac6d2508b6a82dc143.svg";